/* Wholesale Veronese — locks every checkout button (cart page, cart drawer, dynamic/express buttons)
   while the cart summary reports data-ws-blocked="true". The summary is rendered by
   snippets/wholesale-cart-status.liquid and re-rendered by the theme after each cart change. */
(function () {
  function blocked() {
    return !!document.querySelector('.wholesale-cart[data-ws-blocked="true"]');
  }
  function apply() {
    var b = blocked();
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (el) {
      if (b) {
        if (!el.hasAttribute('disabled')) el.dataset.wsLocked = '1';
        el.setAttribute('disabled', '');
      } else if (el.dataset.wsLocked) {
        el.removeAttribute('disabled');
        delete el.dataset.wsLocked;
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.style.display = b ? 'none' : '';
    });
  }
  function stop(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (t && blocked()) stop(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (blocked() && s && s.name === 'checkout') stop(e);
  }, true);
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', apply);
  apply();
})();
